'use strict';

const $ = require('jquery');

class Squares {

    constructor() {

        App.Globals.$window.on('load resize calculate:squares', function () {

            $('[data-square]').each(function () {

                let $this = $(this);
                let width = $this.width();

                $this.height(width);
            });
        });
    }
}

module.exports = Squares;
